import React, { CSSProperties } from 'react';
import { Card } from 'styleguide/Card';
import { P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import DownloadAppstore from 'assets/download-appstore.svg';
import DownloadGooglePlay from 'assets/download-googleplay.svg';
import { SecondaryButton } from 'styleguide/Buttons';
import { t } from 'translations/t';

interface Props {
  username: string;
  onCopyPress: () => void;
  style?: CSSProperties;
}

export const AppStoresCard = ({ username, onCopyPress, style }: Props) => {
  return (
    <View style={style}>
      <Card style={{ padding: 16, marginBottom: 16 }}>
        <P2 style={{ paddingBottom: 16 }}>
          {t('web.workoutDetails.exercise.title', { username })}
        </P2>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '16px',
          }}
        >
          <a href="https://hevyapp.app.link/z8OJYs7sUqb">
            <DownloadAppstore style={{ height: 48 }} />
          </a>
          <a href="https://hevyapp.app.link/onXEhIQsUqb">
            <DownloadGooglePlay style={{ height: 48 }} />
          </a>
        </View>
      </Card>
      <SecondaryButton title={t('web.workoutDetails.exercise.copyLink')} onClick={onCopyPress} />
    </View>
  );
};
